var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bootstrap-styles"},[_c('modal',{attrs:{"name":"nlp-analysis-tool-modal","height":"auto","styles":{'border-radius': '10px 10px 3px 3px'},"width":'450px'},on:{"before-close":_vm.beforeClose}},[_c('nlp-analysis')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }